import React from 'react';
import { ScrollReveal } from './useScrollReveal';
export function CostComparisonSection() {
  const costs = [{
    sin: 'Cada crisis emocional sin protocolo',
    costo: 'Horas de desgaste familiar + relación dañada'
  }, {
    sin: 'Conversaciones que terminan en pelea',
    costo: 'Distancia emocional que se acumula con los años'
  }, {
    sin: 'Ansiedad del adolescente sin herramientas',
    costo: 'Rendimiento escolar y social deteriorado'
  }, {
    sin: 'Autoestima que depende de likes',
    costo: 'Identidad frágil construida en arena'
  }, {
    sin: 'Conflictos familiares sin sistema',
    costo: 'El mismo ciclo, el próximo año'
  }, {
    sin: 'Docente sin herramientas de intervención',
    costo: 'Crisis en el aula que escalan sin necesidad'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-800" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <ScrollReveal direction="up" className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-43">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </ScrollReveal>

        <div className="bg-navy-900 rounded-2xl overflow-hidden border border-navy-700 shadow-2xl" data-id="element-44">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-navy-800 border-b border-navy-700" data-id="element-45">
            <div className="p-6 font-bold text-slate-300 hidden md:block" data-id="element-46">
              Sin MegaPack
            </div>
            <div className="p-6 font-bold text-red-400 hidden md:block" data-id="element-47">
              Costo real
            </div>
          </div>

          <div className="divide-y divide-navy-800/50" data-id="element-48">
            {costs.map((item, index) => <ScrollReveal key={index} direction="left" delay={index + 1} className="grid grid-cols-1 md:grid-cols-2 hover:bg-navy-800/30 transition-colors" data-id="element-49">
                <div className="p-5 md:p-6 text-slate-300" data-id="element-50">
                  <span className="md:hidden font-bold text-slate-500 text-xs uppercase tracking-wider block mb-1" data-id="element-51">
                    Sin MegaPack
                  </span>
                  {item.sin}
                </div>
                <div className="p-5 md:p-6 text-red-300/90 font-medium bg-red-500/5 md:bg-transparent border-t border-navy-800 md:border-t-0 md:border-l border-navy-800/50" data-id="element-52">
                  <span className="md:hidden font-bold text-red-500/50 text-xs uppercase tracking-wider block mb-1" data-id="element-53">
                    Costo real
                  </span>
                  {item.costo}
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </div>
    </section>;
}